import styled from 'styled-components'

export const FormGroupWrapper = styled.div`
  position: relative;
  min-height: 48px;
`

export const SelectInput = styled.input`
  display: none;
`

export const SelectInputLabel = styled.div`
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ disabled, theme }) => (disabled ? 'transparent' : theme.colors.backgroundLite)};
  transition: 0.4s;

  position: relative;
  // TODO: Use theme functions
  &:after {
    content: '';

    position: absolute;
    top: 42%;
    right: 15px;

    display: ${({ disabled }) => (disabled ? 'none' : 'inline-block')};
    margin-left: 0.255em;
    vertical-align: 0.255em;

    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
    color: ${({ theme }) => theme.colors.primary};
  }

  min-height: 54px;
  height: fit-content;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;

  border: ${({ theme }) => `1px solid ${theme.colors.borderColor}`};
`

export const SelectInputOptionsContainer = styled.div`
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: auto;

  padding: 10px 15px;
  width: 100%;

  font-size: 14px;
  border-radius: 10px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme }) => theme.colors.background};
  border: ${({ theme }) => `1px solid ${theme.colors.borderColor}`};
  user-select: none;
  z-index: 4;
`

export const SelectInputOptions = styled.div`
  display: flex;
  padding: 10px;

  cursor: pointer;
  transition: 0.4s;

  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 10px;

  min-width: 40px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    border: ${({ theme }) => `1px solid ${theme.colors.borderColor}`};
  }
`

export const Abbreviation = styled.div`
  color: ${({ theme }) => theme.colors.backgroundLite};
  min-width: 40px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
